import { Model } from "@vuex-orm/core";
import config from "../configs/Majority";

export default class Majority extends Model {
  static get entity() {
    return "majorities";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      majority_conditions: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
